const LOADING_TYPES = {
  SAVE_REPORT: 'Saving report...',
  GENERATE_REPORT: 'Generating report...',
  GENERATE_FINDING: 'Generating finding...',
  STOPPING_AI_PROCESS: 'Stopping AI process...',
  UPLOADING_REPORT: 'Uploading report...',
};

export default LOADING_TYPES;
